import { render, staticRenderFns } from "./Interwinner.vue?vue&type=template&id=33025a2a&scoped=true"
import script from "./Interwinner.vue?vue&type=script&lang=ts"
export * from "./Interwinner.vue?vue&type=script&lang=ts"
import style0 from "./Interwinner.vue?vue&type=style&index=0&id=33025a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33025a2a",
  null
  
)

export default component.exports